import { lazy } from 'react';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';

const Providers = lazy(() => import('@pages/providers'));

// DS-only (backend guidance 2026-07-23): providers moved out of the
// left navigation into the accounts-list row menu, so the route now
// carries the selected account in the child-context URL shape and is
// gated by the DS marker permission (ACCOUNTS_GET).
const PROVIDER_ROUTE_LIST = {
  path: '/:currentAccountUuid/accounts/:accountUuid/providers',
  exact: true,
  additional: {
    component: Providers,
    protected: true,
    title: i18next.t('titles:providers'),
    permission: permissions.ACCOUNTS_GET,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.providers || 'Providers',
    },
  },
};

export const PROVIDER_ROUTES = {
  list: PROVIDER_ROUTE_LIST,
};
